<template>
  <div>
    <p class="m-content overflow-line" id="J_description" v-html="introduce"></p>
    <button type="button" class="btn-more" v-if="isShowMore" id="J_btnmore" @click="showmoreDesc($event)"></button>
  </div>
</template>
<script>
  export default {
    name: 'TexcCollapse',
    data() {
      return {
        isShowMore: false,
        isDescStatus: true,
        introduce: ""
      };
    },
    props: {
      content: {
        type: String,
        default: ""
      }
    },
    methods: {
      showmoreDesc(e) {
          let el = e.currentTarget;
          el.previousElementSibling.classList[!this.isDescStatus ? 'add' : 'remove']('overflow-line');
          el.classList[this.isDescStatus ? 'add' : 'remove']('more-collapse');
        // el.innerHTML = !this.isDescStatus ? '查看更多' : '收起';
          this.isDescStatus = !this.isDescStatus;
          this.isShowMore = true;
      }
    },
    watch: {
        "content":{
            immediate:true,
            deep: true,
            handler:function(val){
                this.introduce = val;
                if (this.introduce.length > 75) {
                    this.isShowMore = true;
                }
            }
        }
    }
  };
</script>

<style lang="less" scoped>
  .m-content {
    &.overflow-line {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }

 .btn-more {
    background-color:#ffffff;
    background-image:url(../assets/images/expand.png);
    background-position:center right;
    background-size: 25px 25px;
    background-repeat:no-repeat ;
    width:100%;
    border:none;
    height:30px;
 }
.more-collapse {
    background-color:#ffffff;
    background-image:url(../assets/images/shrink.png);
    background-position: center right;
    background-size: 25px 25px;
    background-repeat:no-repeat ;
    width:100%;
    border:none;
    height:30px;
}

</style>


// WEBPACK FOOTER //
// src/components/TextCollapse.vue